import IPassword from '../models/password/IPassword';
import IErrorResponse from '../models/networking/IErrorResponse';
import networkService from './networkService';

class PasswordService {

    async getPasswords(folderId: string): Promise<IPassword[]> {
        const result = await networkService.get<IPassword[]>(`/passwords?folderId=${folderId}`);

        if (result.isSuccessful) {
            return result.status === 200
                ? result.data as IPassword[]
                : [];
        } else {
            const error = result.data as IErrorResponse;
            throw new Error(error.message);
        }
    }

    async getPassword(passwordId: string): Promise<IPassword> {
        const result = await networkService.get(`/password/${passwordId}`);

        if (result.isSuccessful) {
            return result.data as IPassword;
        }

        const error = result.data as IErrorResponse;
        throw new Error(error.message);
    }

    async getPasswordValue(passwordId: string): Promise<string> {
        const result = await networkService.get(`/password/${passwordId}/password`);

        if (result.isSuccessful) {
            return result.data as string;
        }

        const error = result.data as IErrorResponse;
        throw new Error(error.message);
    }

    async createPassword(password: IPassword): Promise<void> {
        const result = await networkService.put('/password', password);

        if (!result.isSuccessful) {
            const error = result.data as IErrorResponse;
            throw new Error(error.message);
        }
    }

    async updatePassword(password: IPassword): Promise<void> {
        const result = await networkService.patch('/password', password);

        if (!result.isSuccessful) {
            const error = result.data as IErrorResponse;
            throw new Error(error.message);
        }
    }

    async deletePassword(passwordId: string): Promise<void> {
        const result = await networkService.delete(`/password/${passwordId}`);

        if (!result.isSuccessful) {
            const error = result.data as IErrorResponse;
            throw new Error(error.message);
        }
    }

}

const passwordService = new PasswordService();
export default passwordService;